<template>
  <div class="filter-header">
    <div>
      <h2>{{ isShortText ? 'Filter' : 'Nachrichten filtern' }}</h2>
      {{
        count === 0
          ? `Keine Nachrichten${isShortText ? '' : ' gefunden'}`
          : count === 1
            ? `1 Nachricht${isShortText ? '' : ' gefunden'}`
            : `${count} Nachrichten${isShortText ? '' : ' gefunden'}`
      }}
    </div>
    <span
      @click="close"
      ref="closeButton"
      class="icon icon-x close-filter-bottom-sheet"
      tabindex="0"
      @keydown.prevent.enter="close"
      @keydown.prevent.space="close"
    ></span>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useWindowSize } from '@vueuse/core'

const { width } = useWindowSize()

defineProps<{
  count: number
}>()

const emit = defineEmits(['close'])

const closeButton = ref<HTMLElement | null>(null)
defineExpose({ closeButton })

const close = () => {
  emit('close')
}

const isShortText = computed(() => {
  return (
    (width.value >= 600 && width.value < 650) || (width.value >= 800 && width.value < 950)
  )
})
</script>

<style lang="scss" scoped>
.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 8px;
  padding-bottom: 14px;

  h2 {
    margin: 0 !important;
    line-height: 15px !important;
  }

  .close-filter-bottom-sheet {
    cursor: pointer;
    background-color: white;
    border-radius: 50%;
    padding: 3px;
    font-size: 23px;
    border: 1px solid #405282;
    @media (min-width: 600px) {
      margin-top: -6px;
    }
  }

  .icon-x:focus-visible {
    outline: 2px solid var(--primary-color-0);
    outline-offset: 2px;
  }
}
</style>
